import { isRef, onUnmounted, watchEffect } from 'vue'

let instanceCounter = 0

export function useHighlight(containerRef, query, trigger) {
  if (!CSS?.highlights || typeof Highlight === 'undefined') return

  const key = `search-match-${++instanceCounter}`
  const hl = new Highlight()
  CSS.highlights.set(key, hl)

  function rebuild() {
    const container = isRef(containerRef) ? containerRef.value : containerRef
    const q = (isRef(query) ? query.value : query)?.trim()
    // read trigger so watchEffect tracks it as a dep
    if (trigger != null) void (isRef(trigger) ? trigger.value : trigger)

    hl.clear()
    if (!q || !container) return

    const re = new RegExp(q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi')
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
    let node
    while ((node = walker.nextNode())) {
      let match
      while ((match = re.exec(node.textContent)) !== null) {
        const range = new Range()
        range.setStart(node, match.index)
        range.setEnd(node, match.index + match[0].length)
        hl.add(range)
      }
    }
  }

  // flush: 'post' runs after Vue finishes updating the DOM
  watchEffect(rebuild, { flush: 'post' })

  onUnmounted(() => {
    CSS.highlights.delete(key)
  })
}
